/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CampaignAudience } from './CampaignAudience';
import {
    CampaignAudienceFromJSON,
    CampaignAudienceFromJSONTyped,
    CampaignAudienceToJSON,
} from './CampaignAudience';

/**
 * 
 * @export
 * @interface FindCampaignAudiences200Response
 */
export interface FindCampaignAudiences200Response {
    /**
     * 
     * @type {Array<CampaignAudience>}
     * @memberof FindCampaignAudiences200Response
     */
    data?: Array<CampaignAudience>;
}

/**
 * Check if a given object implements the FindCampaignAudiences200Response interface.
 */
export function instanceOfFindCampaignAudiences200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindCampaignAudiences200ResponseFromJSON(json: any): FindCampaignAudiences200Response {
    return FindCampaignAudiences200ResponseFromJSONTyped(json, false);
}

export function FindCampaignAudiences200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindCampaignAudiences200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CampaignAudienceFromJSON)),
    };
}

export function FindCampaignAudiences200ResponseToJSON(value?: FindCampaignAudiences200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CampaignAudienceToJSON)),
    };
}

